// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iOCk6rpqsJOZuGbGPspJ {
  height: 100%;
  background: #f7f8f9;
}
.XY0WxznCtSvSyW6fYb3S {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background: #fff;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Organizations/Success/index.module.less"],"names":[],"mappings":"AACA;EACE,YAAA;EACA,mBAAA;AAAF;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AADF","sourcesContent":["\n.container {\n  height: 100%;\n  background: #f7f8f9;\n}\n\n.content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  background: #fff;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `iOCk6rpqsJOZuGbGPspJ`,
	"content": `XY0WxznCtSvSyW6fYb3S`
};
export default ___CSS_LOADER_EXPORT___;
